import { subscribedKey } from './config';

export default function() {
  if (!window || !window.localStorage) {
    return;
  }
  window.localStorage.setItem(subscribedKey, true.toString());
}
